import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { CommonResult } from '../../../external/Common';
import { actions } from '../../modules/Actions';

export interface MailTemplateApplyState {
  result: CommonResult;
}

export const initialState: MailTemplateApplyState = {
  result: {
    jobDateTime: '',
    resultCd: ''
  }
};

export const MailTemplateApplyReducer = reducerWithInitialState(initialState)
  .case(
    actions.applyMailTemplate, (state: MailTemplateApplyState, payload: MailTemplateApplyState) => {
      return payload;
    }
  );
